import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
// ProtectedRoute component to protect certain routes
const ProtectedRoute = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const location = useLocation();
  const [isRegistered, setRegistered] = useState(() => {
    const storedValue = localStorage.getItem("isRegistered");
    return storedValue === "false" ? false : true; // Explicitly handle "false" as a string
  });

  useEffect(() => {
    const newToken = localStorage.getItem("token");
    const registrationStatus = localStorage.getItem("isRegistered");
    if (newToken) {
      setToken(newToken);
    }
    setRegistered(registrationStatus === "false" ? false : true); // Ensure proper boolean handling
  }, []);

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (isRegistered === false && location.pathname !== '/register/about') {
    return <Navigate to="/register/about" />;
  }


  // If token exists, allow the user to access the protected page
  return children;
};

export default ProtectedRoute;
